import { render } from "./MyButton.vue?vue&type=template&id=d38a2660&scoped=true"
import script from "./MyButton.vue?vue&type=script&lang=js"
export * from "./MyButton.vue?vue&type=script&lang=js"

import "./MyButton.vue?vue&type=style&index=0&id=d38a2660&lang=less&scoped=true"

import exportComponent from "/Users/xzang/workspace/opensource/fengxie/nice-dag/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d38a2660"]])

export default __exports__